import styled from 'styled-components';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Button, FormText, FormItem as RowFormItem, Modal } from 'ui';
import { Row, Col } from 'antd';
// eslint-disable-next-line
import ReferenceDataDropdown from 'common/reference-data/containers/reference-data-dropdown-container';

const OrderModal = styled(Modal)`
  .ant-modal-header {
    background-color: #fff;
    border-color: #fff;
    padding-bottom: 0;
  }
  .ant-modal-body {
    padding-top: 0;
  }
  .ant-modal-close {
    color: rgba(100, 116, 124, 0.85);
  }

  .ant-legacy-form-item-label {
    text-align: left;
    overflow: unset;
    vertical-align: unset;
    line-height: 12pt;
    margin-bottom: 10px;
  }
`;

const FormItem = styled(RowFormItem)`
  .ant-legacy-form-item-label  {
    height: auto !important;
    line-height: unset !important;
    > label {
      white-space: pre;
    }
  }
  .ant-select {
    width: 100%;
  }
`;

const ButtonGroup = styled.div`
  margin-top: 20px;
  text-align: right;
`;

const CancelButton = styled(Button)`
  margin-right: 20px;
`;
class AddSuborderDialog extends Component {
  static propTypes = {
    onAddSubOrder: PropTypes.func,
    visible: PropTypes.bool,
    onClose: PropTypes.func,
    isLoading: PropTypes.bool,
    value: PropTypes.object,
    engineer: PropTypes.object,
    defaultEngineer: PropTypes.object,
    intl: PropTypes.object,
    groups: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      filter: PropTypes.func.isRequired,
    })),
    transformValues: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const { engineer } = this.props;
    this.state = {
      technicianNumber: engineer && engineer.number,
      technicianName: engineer && engineer.name,
    };
  }

  onEngineerChange = (engineer) => {
    this.setState({
      technicianNumber: engineer && engineer.number,
      technicianName: engineer && engineer.name,
    });
  };

  render() {
    const {
      onAddSubOrder,
      visible,
      onClose,
      isLoading,
      value,
      defaultEngineer,
      intl,
      groups,
      transformValues,
    } = this.props;
    const { technicianNumber, technicianName } = this.state;

    return (
      <OrderModal
        title={intl.formatMessage({ id: 'order.fieldEngineer.addSubOrderModal.ADD_SUBORDER' })}
        open={visible}
        footer={null}
        onCancel={onClose}
        width='350px'
      >
        <Row>
          <Col md={20} sm={24} xs={24}>
            <FormItem
              label={
                <FormattedMessage
                  id='order.fieldEngineer.addSubOrderModal.ADD_FSE'
                  values={{ br: '\n' }}
                />
              }
            >
              <FormText>
                <ReferenceDataDropdown
                  width={'300px'}
                  isSorted={true}
                  groups={groups}
                  placeholder={intl.formatMessage({ id: 'order.groupDropdown.DROPDOWN_DEFAULT' })}
                  disabled={false}
                  isGrouped={true}
                  type='order'
                  name='workCenters'
                  valueKey='number'
                  valueLabel='name'
                  onObjectChanged={this.onEngineerChange}
                  firstOption={defaultEngineer &&
                    defaultEngineer.number
                  }
                  value={this.state.technicianNumber}
                  transformValues={transformValues}
                />
              </FormText>
            </FormItem>
          </Col>
        </Row>
        <ButtonGroup>
          <CancelButton type='default' onClick={onClose} disabled={isLoading}>
            {intl.formatMessage({ id: 'order.fieldEngineer.addSubOrderModal.CANCEL' })}
          </CancelButton>
          <Button
            type='secondary'
            onClick={() => onAddSubOrder(technicianNumber, technicianName)}
            disabled={(!value || value.name === '') && !this.state.technicianNumber}
            loading={isLoading}
          >
            {intl.formatMessage({ id: 'order.fieldEngineer.addSubOrderModal.OK' })}
          </Button>
        </ButtonGroup>
      </OrderModal>
    );
  }
}

export default injectIntl(AddSuborderDialog);
